const Gallery = ({url}) => {
    return (
        <>
            <img src={url} className='GalleryImage'/>
        </>
    )    
}

export default Gallery;